import { Link } from '@inertiajs/react'
import { ExternalLink } from 'lucide-react'
import type { OrganizationUpload as Upload } from '@/types'
import StatusBadge from './StatusBadge'

interface StatusCardProps {
    upload: Upload
}

export default function StatusCard({upload}: StatusCardProps) {
    return (
        <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="p-6">
                <div className="flex items-center justify-between">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">Status</h3>
                    <StatusBadge status={upload.status} hasErrors={upload.has_errors}/>
                </div>

                <div className="mt-6 space-y-4">
                    <dl className="space-y-3 text-sm">
                        <div>
                            <dt className="font-medium text-gray-700">Import Mode</dt>
                            <dd className="text-gray-900 capitalize">
                                {upload.import_mode}
                            </dd>
                        </div>
                        {upload.organization && (
                            <div>
                                <dt className="font-medium text-gray-700">Organization</dt>
                                <dd className="text-gray-900">
                                    <Link
                                        href={`/admin/organizations/${upload.organization.id}`}
                                        className="inline-flex items-center text-indigo-600 hover:text-indigo-700 hover:underline"
                                    >
                                        {upload.organization.name}
                                        <ExternalLink className="w-3 h-3 ml-1"/>
                                    </Link>
                                </dd>
                            </div>
                        )}

                        <div>
                            <dt className="font-medium text-gray-700">Created</dt>
                            <dd className="text-gray-900">{upload.created_at}</dd>
                        </div>

                        {upload.processing_started_at && (
                            <div>
                                <dt className="font-medium text-gray-700">Started Processing</dt>
                                <dd className="text-gray-900">{upload.processing_started_at}</dd>
                            </div>
                        )}

                        {upload.processed_at && (
                            <div>
                                <dt className="font-medium text-gray-700">Completed</dt>
                                <dd className="text-gray-900">{upload.processed_at}</dd>
                            </div>
                        )}

                        {upload.processing_duration && (
                            <div>
                                <dt className="font-medium text-gray-700">Duration</dt>
                                <dd className="text-gray-900">{upload.processing_duration}</dd>
                            </div>
                        )}
                    </dl>
                </div>
            </div>
        </div>
    )
}